(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/collections/coupons.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/collections/coupons.js'); 
(function(Backbone, _, svs) {
  'use strict';

  svs.maltipset.collections.Coupons = Backbone.Collection.extend({
    model: svs.maltipset.models.Coupon,
    currentCouponIndex: 0,
    initialize: function() {
      this.draws = svs.maltipset.collections.draws;
      this.createCoupons();
    },
    createCoupons: function() {
      var self = this;

      this.draws.each(function(draw) {
        self.createCoupon(draw);
      });
    },
    createCoupon: function(draw) {
      var newCoupon = new svs.maltipset.models.Coupon({ draw: draw });
      this.add(newCoupon);

      return newCoupon;
    },
    getCurrentCoupon: function() {
      return this.at(this.currentCouponIndex);
    },
    setCurrentCoupon: function(drawNumber) {
      var self = this;
      self.currentDrawIndex = 0;

      if (!drawNumber) {
        self.draws
          .at(0)
          .get('matchList')
          .setTipsInfoDataListener();
        return;
      }

      this.each(function(coupon, index) {
        if (coupon.get('draw').get('drawNumber') == drawNumber) {
          self.currentCouponIndex = index;
          self.draws.currentDrawIndex = index;
          self.draws
            .at(index)
            .get('matchList')
            .setTipsInfoDataListener();
        } else {
          self.draws
            .at(index)
            .get('matchList')
            .removeTipsInfoDataListener();
        }
      });
    },
    hasManyDraws: function() {
      return this.draws.length > 1;
    }
  });
})(Backbone, _, svs);

 })(window);